import { render } from "./S110944.vue?vue&type=template&id=4a15b820"
const script = {}
script.render = render

export default script